import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { CONSOLE_TABS } from './constants/consoleConstants';
import ConsoleTabsNav from './components/console/ConsoleTabsNav';
import ConsoleDashboardTab from './components/console/tabs/ConsoleDashboardTab';
import StandardQATab from './components/console/tabs/StandardQATab';
import EvaluationTab from './components/console/tabs/EvaluationTab';
import ReviewTab from './components/console/tabs/ReviewTab';
import PolicyTab from './components/console/tabs/PolicyTab';
import HistoryTab from './components/console/tabs/HistoryTab';
import SettingsTab from './components/console/tabs/SettingsTab';
import HealthTab from './components/console/tabs/HealthTab';

const ConsolePage = () => {
    const { pathname } = useLocation();

    // 상위 Nav 표시를 위해 현재 활성 탭 식별 (기본값 dashboard)
    const activeTab = CONSOLE_TABS.find(t =>
        (t.key === 'dashboard' && pathname === '/ai/admin/console') ||
        (t.key !== 'dashboard' && pathname.startsWith(t.path))
    ) || CONSOLE_TABS[0];

    return (
        <div className="p-6 pb-10 md:p-8">
            {/* 공통 상단 헤더 */}
            <header className="mb-4">
                <h1 className="text-2xl font-bold tracking-tight text-sb-header">
                    AI 품질 관리
                </h1>
                <p className="mt-1 text-sm text-gray-500">산업안전보건법 AI 챗봇 품질 관리 — {activeTab.label}</p>
            </header>

            {/* 탭 네비게이션바 (2차 메뉴) */}
            <ConsoleTabsNav />

            {/* 하위 라우트로 내부 콘텐츠 실시간 교체 */}
            <div className="mt-4">
                <Routes>
                    <Route index element={<ConsoleDashboardTab />} />
                    <Route path="standard-qa" element={<StandardQATab />} />
                    <Route path="evaluation" element={<EvaluationTab />} />
                    <Route path="review" element={<ReviewTab />} />
                    <Route path="policy" element={<PolicyTab />} />
                    <Route path="history" element={<HistoryTab />} />
                    <Route path="settings" element={<SettingsTab />} />
                    <Route path="health" element={<HealthTab />} />
                    <Route path="*" element={<Navigate to="/ai/admin/console" replace />} />
                </Routes>
            </div>
        </div>
    );
};

export default ConsolePage;